module.exports = __webpack_public_path__ + "static/img/sp23.5aae715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp23.jpg
// module id = d5yn
// module chunks = 0